import { FileDto } from '@act/shared/data-transfer-objects';
import { Dialog } from '@mui/material';
import styled from 'styled-components';
import ViewFile from './ViewFile';

const ViewFileDialog = (props: {
  file: FileDto;
  open: boolean;
  onClose: () => void;
}) => {
  return (
    <Dialog onClose={props.onClose} open={props.open}>
      <StyledDiv>
        <ViewFile file={props.file} />
      </StyledDiv>
    </Dialog>
  );
};

const StyledDiv = styled.div`
  padding: 8px;
`;

export default ViewFileDialog;
